import getSelectedAccessibilityOption from '../selectors/getSelectedAccessibilityOption';
import getPreferAccessibleContentOption from '../selectors/getPreferAccessibleContentOption';

/**
 * Utility function which returns if the option value is dirty or not.
 */
export default function isAccessibilityOptionDirty(): boolean {
    return getSelectedAccessibilityOption() != getPreferAccessibleContentOption();
}
